import {twMerge} from "tailwind-merge";
import {Fragment} from "react";

export default function StepLine({steps = [], activeStep, classes = {}}) {

    const {parentClasses = ""} = classes;

    return (
        <div className={twMerge("flex justify-between", parentClasses)}>
            {
                steps.map((step, index) => (
                    <Fragment key={step.id}>
                        <div className="relative" style={{maxWidth: `${100/steps.length}%`}}>
                            {
                                index + 1 === steps.length ? null :
                                    <div
                                        className={`absolute w-[calc(50%-0.6875rem)] top-2.5 left-0 h-0.5 ${activeStep > step.id ? "bg-pol-green-2" : "bg-pol-purple-4"}`}/>
                            }
                            {
                                index !== 0 ?
                                    <div
                                        className={`absolute w-[calc(50%-0.6875rem)] top-2.5 right-0 h-0.5 ${activeStep >= step.id ? "bg-pol-green-2" : "bg-pol-purple-4"}`}/>
                                    : null
                            }
                            <div
                                className={`w-[1.375rem] h-[1.375rem] mx-auto flex-center rounded-md border-2 ${activeStep >= step.id ? "border-pol-green-2" : "border-pol-purple-4"} ${activeStep > step.id ? "bg-pol-green-2" : ""}`}>
                                {
                                    activeStep === step.id ?
                                        <div className="w-3 h-3 bg-pol-green-2 rounded-[0.188rem]"/> : null
                                }
                            </div>
                            <p className={`font-semibold text-xs xl:text-sm mt-1.5 text-center ${activeStep === step.id ? "" : "xl:block hidden"} ${activeStep >= step.id ? "text-pol-green-2" : "text-pol-purple-5"}`}>{step.title}</p>

                        </div>
                        {
                            index + 1 === steps.length ? null :
                                <div className="relative flex-grow h-[1.375rem] flex items-center">
                                    <div
                                        className={`w-full right-0 h-0.5 ${activeStep > step.id ? "bg-pol-green-2" : "bg-pol-purple-4"}`}/>
                                </div>
                        }
                    </Fragment>
                ))
            }
        </div>
    )
}
